<template>
    <div v-if="$store.getters.isLoggedIn && purchase.flags.is_customer && purchase.actions.customer.supplementary_agreement === 'create'">
        <b-dropdown text="ЗАКЛЮЧИТЬ ДОПОЛНИТЕЛЬНОЕ СОГЛАШЕНИЕ" variant="custom-green" v-if="!createSupplementaryAgreement">
            <b-dropdown-item class="fs-14" v-for="type in $globalDictionaries.fl44SupplementaryAgreementTypes" :key="type.id" @click="createClicked(type.id)">{{ type.title }}</b-dropdown-item>
        </b-dropdown>

        <component :is="createComponent" v-else @cancel="createSupplementaryAgreement = false" :pivc="pivc" :purchase="purchase" @done="onSend" />
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Fl44ContractSupplementaryAgreementRegularCreate from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-regular-create.vue';
import Fl44ContractSupplementaryAgreementTerminationCreate from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-termination-create.vue';

export default {
    name: 'private-customer-fl44-contract-supplementary-agreement-create-block',
    components: { Fl44ContractSupplementaryAgreementTerminationCreate, Fl44ContractSupplementaryAgreementRegularCreate },
    props: {
        purchase: {
            type: Object,
            required: true
        },
        pivc: {
            type: Object
        }
    },
    data() {
        return {
            createSupplementaryAgreement: false,
            form: {
                attachment: null
            },
            formDisagreement: {
                contract: null,
                disagreement: null
            },
            isDataSending: false,
            type: 'regular'
        };
    },
    validations() {
        return {
            form: {
                attachment: {
                    required
                }
            },
            formDisagreement: {
                contract: {
                    required
                },
                disagreement: {
                    required
                }
            }
        };
    },
    methods: {
        createClicked(typeId) {
            this.type = typeId;
            this.createSupplementaryAgreement = true;
        },
        onSend() {
            this.createSupplementaryAgreement = false;
            this.$emit('refresh', null);
        }
    },
    computed: {
        createComponent() {
            switch (this.type) {
                case 'termination':
                    return Fl44ContractSupplementaryAgreementTerminationCreate;
                default:
                    return Fl44ContractSupplementaryAgreementRegularCreate;
            }
        }
    }
};
</script>
